import { SparklineChart } from '@/components/ui/sparkline-chart';
import type { AuiRendererProps } from '../../registry';

export function AuiSparkline({ node }: AuiRendererProps) {
  const props = node.component.props ?? {};
  const data = (props.data as number[]) ?? [];
  const variant = (props.variant as 'line' | 'bar') ?? 'line';
  const height = (props.height as number) ?? 32;
  const color = props.color as 1 | 2 | 3 | 4 | 5 | string | undefined;
  const showArea = props.showArea as boolean | undefined;
  const showTooltip = props.showTooltip as boolean | undefined;

  return (
    <div data-testid="aui-sparkline">
      <SparklineChart
        data={data}
        variant={variant}
        height={height}
        color={color}
        showArea={showArea}
        showTooltip={showTooltip}
      />
    </div>
  );
}
